import { render, staticRenderFns } from "./ViewTaskAttach.vue?vue&type=template&id=5b0fd73e"
import script from "./ViewTaskAttach.vue?vue&type=script&lang=js"
export * from "./ViewTaskAttach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports